module.exports = __webpack_public_path__ + "img/logo.2f87b00a.png";